import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { catchError, map, tap, filter, switchMap, startWith, flatMap } from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../../../store/state/app.state';
import {MonitoringService} from '../../utility/monitoring/monitoring.service';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import * as _ from 'lodash';
import {IRaceResult} from '../../../models/raceresult';
import {IRace} from '../../../models/race.interface';
import {IIdentify} from '../../../models/identify.interface';
import {selectIdentify} from '../../../store/selectors/identify.selectors';
import {UrlControllerService} from '../../url-controller.service';

@Injectable({
  providedIn: 'root'
})
export class RaceResultService extends UrlControllerService{
    public identify$: Observable<IIdentify>;
  /**
   * Url of api
   */
  private apiUrlResult: string;
  public statoQf = '0';
  public statoTot = '0';
  public statoPsr = '0';

  /**
   * Costructor service
   * @param http take http client module
   * @param _store ngrx store to select first place
   * @param monitoringService service to log and monitoring
   */
  constructor(
      private http: HttpClient,
      public _store: Store<IAppState>,
      private monitoringService: MonitoringService,
  ) {
      super(_store);
      // this.apiUrlResult = this.apiUrlSelected + 'rest/program/';
      this.identify$ = this._store.pipe(select(selectIdentify));
      this.identify$.subscribe((x) => {
          if (x) {
              this.statoQf = x.stato_qf;
              this.statoTot = x.stato_tot;
              this.statoPsr = x.stato_psr;
          }
      });
  }
  getRaceresult(): Observable<IRaceResult> {
        return this.http.get<any>(this.apiUrlSelected + 'rest/program/last').pipe(
        map(result => {
          if ( result && result.race) {
             result = result.race;
             result.forEach(function (element) {
                 element.result = _
                    .chain(element.result)
                    .sortBy('pos')
                     .value();
             });
              result = result.filter((race) => this.availableRace(race));
            return result;
          }
        }),
        catchError(this.monitoringService.handleError<IRaceResult>(`getRaceresult`, null))
    );
  }

    availableRace(race): boolean {
        return (
            (race.tot === '1' && this.statoTot === '1') ||
            (race.tot === '1' && this.statoPsr === '1') ||
            (race.tot === '0' && this.statoQf === '1')
        );
    }
}
